import PropTypes from "prop-types";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import { useParams, useLocation } from "react-router-dom";
import { editTicketData } from "../../../../../redux/slices/tickets";
import MobileUsers from "./MobileUsers";

MobileTicketUsers.propTypes = {
  users: PropTypes.array,
}

export default function MobileTicketUsers({users}) {
  const dispatch = useDispatch();
  const [localTicketUsers, setLocalTicketUsers] = useState(users);
  const { id } = useParams();
  const location = useLocation();
  const subticketId = new URLSearchParams(location.search).get('subticket');
  const { users: possibleUsers } = useSelector((state) => state.tickets.data.ticketInfoById[id] || {});  

  useEffect(() => {
    setLocalTicketUsers(users);
  }, [users]);

  const removeUser = (userId) => {
    const updatedUsers = localTicketUsers?.filter(user => user.id !== userId);
    dispatch(editTicketData({
      Id: subticketId || id,
      value: updatedUsers.map((user) => user.email || user.id),
      updateType: 'Users',
      mainId: id,
    }))
    .then((result) => {
      if (!result) enqueueSnackbar('Failed to remove user', { variant: 'error' });
      else setLocalTicketUsers(updatedUsers);
    })
    .catch(() => enqueueSnackbar('Failed to remove user', { variant: 'error' }));;
  }

  const addNewUser = (newValue) => {
    const updatedNewValue = newValue.map((user) => {
      if(typeof user === 'string') return {id: user, value: user, email: user}
      return user;
    });
    dispatch(editTicketData({
      Id: subticketId || id,
      value: updatedNewValue.map((user) => user.email || user.id),
      updateType: 'Users',
      mainId: id,
    }))
    .then((result) => {
      if (!result) enqueueSnackbar('Failed to add user', { variant: 'error' });
      else setLocalTicketUsers(updatedNewValue);
    })
    .catch(() => enqueueSnackbar('Failed to add user', { variant: 'error' }));;
  }

  return <MobileUsers userOptions={possibleUsers} ticketUsers={localTicketUsers} addUser={addNewUser} removeUser={removeUser}/>
}